module.exports = __webpack_public_path__ + "img/qhse_compressed.f8220cc7.jpg";